<template>
  <v-dialog fullscreen persistent :value="showDialog" transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Edit Schengen Trip</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="$emit('closeEditSchengenRequest')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container class="text-xs-center">
        <v-layout row wrap>
          <v-flex xs12 class="mb-3">
            <div class="datepicker-trigger">
                <div class="text-xs-left">
                  <div class="mt-3 text-xs-left">
                    <h3><strong>Schengen Trip Dates: </strong></h3>
                  </div>
                  <div id="edit-datepicker-trigger" class="text-xs-left">{{dateOne ? formatDates(dateOne, dateTwo) : 'Please select dates for the Schengen trip'}}</div>
                  
                    <!-- Schengen Country selection dropbox -->
                    <v-layout class="mt-3" row wrap>
                    <v-flex xs12 sm6>
                      <v-select v-model="selected_country" :items="schengenCountries" label="Select A Country">
                        <template slot="selection" slot-scope="data">
                          <span v-if="data.item.code" :class="'flag flag-' + data.item.code" style="margin-right: 10px;"></span>
                          {{ data.item.text }}
                        </template>
                        <template slot="item" slot-scope="data">
                          <span v-if="data.item.code" :class="'flag flag-' + data.item.code" style="margin-right: 10px;"></span>
                          {{ data.item.text }}
                        </template>
                      </v-select>
                    </v-flex>
                    </v-layout>

                </div>
                <AirbnbStyleDatepicker :trigger-element-id="'edit-datepicker-trigger'" :mode="'range'" :date-one="dateOne"
                :date-two="dateTwo" @date-one-selected="val => { dateOne = val }" @date-two-selected="val => { dateTwo = val }"
                inline :showActionButtons="false" :showShortcutsMenuTrigger="false" />
            </div>
          </v-flex>
          <v-layout v-if="!selected_country" row>
              <v-flex  style="margin: 0px 0px 15px 0px;">
                <h4>Please select a country</h4>
              </v-flex>
          </v-layout>
          <v-layout v-if="dateOne == '' || dateTwo == ''" row>
              <v-flex  style="margin: 0px 0px 15px 0px;">
                <h4>Please select dates for the Schengen trip</h4>
              </v-flex>
          </v-layout>
          <v-btn color="primary" block class="mb-4" @click="saveTrip" :disabled="dateOne == '' || dateTwo == '' || !selected_country">Save Changes</v-btn>
        </v-layout>
      </v-container>
      
    </v-card>
  </v-dialog>
</template>

<script>
  import format from 'date-fns/format'
  import axios from 'axios'
  export default {
    props: ['showDialog', 'trip'],
    data () {
      return {
        url: this.$store.getters.url,
        dateFormat: 'Do MMMM',
        dateOne: '',
        dateTwo: '',
        user: this.$store.getters.user,
        company: this.$store.getters.company,
        detailsConfirmed: false,
        loading: false,
        schengenCountries: [],
        selected_country: null
      }
    },
    computed: {
    },
    mounted () {
      this.getSchengenCountries()
      this.populateFromTrip()
    },
    methods: {
      formatDates (dateOne, dateTwo) {
        let formattedDates = ''
        if (dateOne) {
          formattedDates = format(dateOne, this.dateFormat)
        }
        if (dateTwo && dateTwo !== dateOne) {
          formattedDates += ' - ' + format(dateTwo, this.dateFormat)
        }
        return formattedDates
      },
      populateFromTrip () {
        if (!this.trip) {
          this.dateOne = ''
          this.dateTwo = ''
          this.selected_country = null
          return
        }
        this.dateOne = this.trip.start_date || ''
        this.dateTwo = this.trip.end_date || ''
        this.setSelectedCountryFromTrip()
      },
      setSelectedCountryFromTrip () {
        if (!this.trip) {
          this.selected_country = null
          return
        }
        if (this.trip.country_id) {
          this.selected_country = this.trip.country_id
          return
        }
        if (this.trip.country && this.schengenCountries.length) {
          const match = this.schengenCountries.find(c => c.text === this.trip.country)
          this.selected_country = match ? match.value : null
        }
      },
      getSchengenCountries () {
        axios.post(this.url + `/tanda-service/getSchengenCountries.ajax.php`, {
          company: this.company
        })
          .then(response => {
            this.schengenCountries = response.data.map(item => ({
              value: item.country_id,
              text: item.country_name,
              code: item.country_code
            }))
            this.setSelectedCountryFromTrip()
          })
          .catch(e => {
            console.log(e)
          })
      },
      saveTrip () {
        this.$emit('editSchengenTrip', {
          trip_id: this.trip ? this.trip.trip_id : null,
          startDate: this.dateOne,
          endDate: this.dateTwo,
          country: this.selected_country
        })
        this.$emit('closeEditSchengenRequest')
      }
    },
    watch: {
      trip: {
        handler () {
          this.populateFromTrip()
        },
        deep: true
      },
      showDialog (val) {
        if (val) {
          this.populateFromTrip()
        }
      }
    },
    filters: {
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/EditSchengenRequest.vue